// source: template-project@7007a338a apps/backoffice/src/design-system/theme.ts
/**
 * Trafiflow UI v3 is the backoffice's theme: `html.ds-test` is on for every
 * screen, always. The class name is historical; it is the selector the
 * generated tokens and the paper theme's remaining rules live under until the
 * "v3 unconditional" PR moves them to `:root`.
 *
 * There is no kill switch. `?dsTest=0` used to take the class off for the
 * tab and show the pre-v3 look; it was retired: without the class the lab
 * utilities fell back to their light-only values (dark text on a dark ground
 * in dark mode), and the primitives of the next PR are built on the `--ds-*`
 * tokens themselves, so they would not fall back at all. The dev tenant mock
 * (src/lib/tenant-mock.ts) has its own `?tenantMock=` flag.
 *
 * `applyDesignSystemTheme` runs once from main.tsx before the first render;
 * public/boot.js adds the same class before the first paint.
 */
export const DESIGN_SYSTEM_HTML_CLASS = 'ds-test';

/** Put the theme class on <html>. Idempotent. */
export function applyDesignSystemTheme(): void {
  document.documentElement.classList.add(DESIGN_SYSTEM_HTML_CLASS);
}
